export type Rng = () => number;

export function createSeededRandom(seed: number): Rng {
  let s = seed >>> 0;
  return () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 0x100000000;
  };
}

export function pick<T>(rng: Rng, arr: readonly T[]): T {
  return arr[Math.floor(rng() * arr.length) % arr.length]!;
}

export function randRange(rng: Rng, a: number, b: number): number {
  return a + (b - a) * rng();
}
